import {
  DataImport,
  DataImportRow,
  DataImportTagResponse,
  DataIngestionStatusApi,
  GetImportDetailsRequest,
  GetImportRequest,
  GetImportTagsRequest,
  SearchImportsRequest,
} from '@Generated/back-office-client/src'
import { BackOfficeDataServiceAPI } from './back-office-data-service'

export type SearchImportsBackOfficeRequest = Omit<SearchImportsRequest, 'customerId'>

const searchImports = async (
  searchRequest: SearchImportsBackOfficeRequest,
): Promise<DataImport[]> => {
  const api = BackOfficeDataServiceAPI.getBackOfficeApi(DataIngestionStatusApi)

  const request: SearchImportsRequest = {
    customerId: BackOfficeDataServiceAPI.getBackOfficeConfig().customerId,
    maxResults: 100,
    ...searchRequest,
  }

  return await api.searchImports(request)
}

const getImportTags = async (): Promise<DataImportTagResponse> => {
  const api = BackOfficeDataServiceAPI.getBackOfficeApi(DataIngestionStatusApi)

  const request: GetImportTagsRequest = {
    customerId: BackOfficeDataServiceAPI.getBackOfficeConfig().customerId,
  }

  return await api.getImportTags(request)
}

const getImportById = async (importId: string): Promise<DataImport> => {
  const api = BackOfficeDataServiceAPI.getBackOfficeApi(DataIngestionStatusApi)

  const request: GetImportRequest = {
    customerId: BackOfficeDataServiceAPI.getBackOfficeConfig().customerId,
    id: importId,
  }

  return await api.getImport(request)
}

const getImportDetails = async (importId: string): Promise<DataImportRow[]> => {
  const api = BackOfficeDataServiceAPI.getBackOfficeApi(DataIngestionStatusApi)

  const request: GetImportDetailsRequest = {
    customerId: BackOfficeDataServiceAPI.getBackOfficeConfig().customerId,
    id: importId,
  }

  return await api.getImportDetails(request)
}

export const DataIngestionServiceAPI = {
  getImportTags,
  searchImports,
  getImportById,
  getImportDetails,
}
